import React, { useState } from "react";
import toast from "react-hot-toast";
import { IoMdChatboxes } from "react-icons/io";
import { FaLinkedin, FaInstagram, FaPhone } from "react-icons/fa";
import { IoMail } from "react-icons/io5";

const Contact = () => {
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const data = new FormData();
    data.append("access_key", "937ccb77-45ba-478e-9539-54bfddfa81d9");
    data.append("first_name", formData.first_name);
    data.append("last_name", formData.last_name);
    data.append("email", formData.email);
    data.append("message", formData.message);

    const submitData = async () => {
      await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        body: data,
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.success) {
            console.log("sent");
            toast.success("Message sent Successfully!", {
              style: {
                background: "#111827",
                color: "#e5e7eb",
              },
            });
          } else {
            console.log("error");
            toast.error("Oops! Please try again.", {
              style: {
                background: "#111827",
                color: "#e5e7eb",
              },
            });
          }
        })
        .catch((error) => {
          toast.error("Try again later.", {
            style: {
              background: "#111827",
              color: "#e5e7eb",
            },
          });
        });
    };
    submitData();
    setFormData({
      first_name: "",
      last_name: "",
      email: "",
      message: "",
    });
  };

  const copyToClipboard = (event) => {
    event.preventDefault();
    const email = "anshuman0799@gmail.com";
    navigator.clipboard
      .writeText(email)
      .then(() => {
        toast.success("Email copied successfully :)", {
          style: {
            background: "#111827",
            color: "#e5e7eb",
          },
        });
      })
      .catch(() => {
        toast.success("Email copying failed", {
          style: {
            background: "#111827",
            color: "#e5e7eb",
          },
        });
      });
  };

  return (
    <main className="mb-24" id="contact">
      <section
        id="contact"
        className=" t-24 max-w-full lg:max-w-[1280px] w-full h-full m-auto px-8"
      >
        <div className="h-full w-full md:w-[85%] mx-auto items-center gap-4">
          <h1 className="text-3xl lg:text-4xl font-titleFont w-full flex justify-center text-black mx-auto mt-10 lg:mb-20 xl:pt-4">
            Contact Me
          </h1>
          <div className="flex flex-col lg:flex-row lg:justify-evenly items-center mt-12 sm:border-2 shadow-custom rounded-2xl bg-white">
            <form
              onSubmit={handleSubmit}
              className="grid lg:grid-cols-2 gap-4 sm:p-8 w-full"
            >
              <input
                type="text"
                name="first_name"
                value={formData.first_name}
                onChange={handleChange}
                placeholder="First Name"
                className="w-full px-6 py-4 bg-white border-2 border-gray-300 rounded-md text-black"
                required
              />
              <input
                type="text"
                name="last_name"
                value={formData.last_name}
                onChange={handleChange}
                placeholder="Last Name"
                className="w-full px-6 py-4 bg-white border-2 border-gray-300 rounded-md"
                required
              />

              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Email"
                className="md:col-span-2 w-full px-6 py-4 bg-white border-2 border-gray-300 rounded-md"
                required
              />
              <div className="md:col-span-2">
                <textarea
                  placeholder="Your message"
                  value={formData.message}
                  onChange={handleChange}
                  name="message"
                  className="w-full px-6 py-4 bg-white border-gray-300 border-2 rounded-md"
                  required
                />
              </div>
              <button
                type="submit"
                className="px-5 py-3 min-w-48 w-full text-sm sm:text-lg font-semibold rounded-lg text-white bg-designColor transition-transform duration-200 hover:shadow-lg hover:-translate-y-1 hover:translate-x-1"
              >
                Send Message
              </button>
            </form>
            <div className="hidden md:block md:max-w-64 lg:max-w-72 xl:max-w-96 w-full p-16">
              <IoMdChatboxes className="h-full w-full text-designColor" />
            </div>
          </div>
          <div className="mt-10 flex gap-0 justify-center translate-x-6 ">
            <a
              href="https://www.linkedin.com/in/anshuman0799/"
              target="_blank"
              rel="noopener noreferrer"
              className="contactIcon "
            >
              <FaLinkedin />
            </a>
            <a
              href="https://www.instagram.com/sh.human/"
              target="_blank"
              rel="noopener noreferrer"
              className="contactIcon"
            >
              <FaInstagram />
            </a>
            <a
              href="mailto:anshuman0799@gmail.com"
              onClick={copyToClipboard}
              className="contactIcon"
            >
              <IoMail />
            </a>
            <a href="tel:+14387781249" className="contactIcon">
              <FaPhone />
            </a>
          </div>
          <h2 className="w-full text-center font-titleFont font-semibold text-xl mt-8 text-gray-600">
            Thanks for visiting!
          </h2>
          <h2 className="w-full text-center text-lg mt-5 text-gray-500">
            © {new Date().getFullYear()} Anshuman. All Rights Reserved.
          </h2>
        </div>
      </section>
    </main>
  );
};

export default Contact;
